module.exports = __webpack_public_path__ + "img/mdjf-bg.52d7a947.png";